import { SET_NEW_CONVERSATION_ID } from '../types/messageConversationId';

export const setNewConversationId = (id) => {
  return {
    type: SET_NEW_CONVERSATION_ID,
    payload: id
  };
};
